import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import Features from '@/components/feature/Features';
import About from '@/components/feature/About';
import Comparison from '@/components/feature/Comparison';
import CategoryGrid from '@/components/feature/CategoryGrid';
import Testimonials from '@/components/feature/Testimonials';
import FaqSection from '@/components/feature/FaqSection';
import CtaSection from '@/components/feature/CtaSection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <About />
        <Comparison />
        <CategoryGrid />
        <Testimonials />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}